module.exports = {
  pricesData: () => {
    return{
      "VENUE LIMITED AT": "$93.990.000",
      "HB20 ADVANCE": "$70.990.000",
      "HB20S ADVANCE": "$71.990.000",
      "KONA HEV LIMITED": "$149.900.000",
      "SANTA FE HEV LIMITED 4x4": "$249.990.000",

      "IONIQ 5 EV-POWER": "$184.990.000",
      "TUCSON HEV LIMITED": "$172.990.000",
      "PALISADE SPORT": "$209.990.000",
      "STARIA LUJO": "$233.990.000",
      "CRETA PREMIUM": "$113.990.000",
    }
  }
}